import { Helpers } from '../../helpers';
import { IConstraintCalendarRestriction } from '../../interfaces/iconstraint-calendar-restriction';
import { AreaType } from '../area-type';
import { ConstraintCalendarRestrictionDetail } from '../constraint-calendar-restriction-detail';
import { Scenario } from '../scenario';

export class ConstraintCalendarRestrictionBase {
  ConstraintCalendarRestrictionId: number;
  ScenarioId: number;
  AreaTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintCalendarRestrictionDetails_ConstraintCalendarRestriction?: Array<ConstraintCalendarRestrictionDetail> | null;
  AreaType?: AreaType;
  Scenario?: Scenario;

  constructor(item?: IConstraintCalendarRestriction) {
    if (item) {

      this.ConstraintCalendarRestrictionId = item.ConstraintCalendarRestrictionId;
      this.ScenarioId = item.ScenarioId;
      this.AreaTypeId = item.AreaTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintCalendarRestrictionDetails_ConstraintCalendarRestriction = Helpers.createClassArray(ConstraintCalendarRestrictionDetail, item.ConstraintCalendarRestrictionDetails_ConstraintCalendarRestriction);
      this.AreaType = new AreaType(item.AreaType);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}